import React, {
  useMemo, useRef,
} from 'react';
import { ReactComponent as MailIconSvg } from 'assets/icons/mail.svg';
import { ReactComponent as PrintIconSvg } from 'assets/icons/print.svg';
import { TranslationFn, useTranslateFn } from 'utils/useTranslateFn';
import styles from './styles.module.scss';
import { TranslationKey } from '../../utils/text-translations';
import { useSetPrinterActions } from '../../../containers/PrinterDependencyInversion/context';

export const emailLink = (pdfUrl: string, email: string, t: TranslationFn<TranslationKey>) => {
  const subject = t('variables.contactEmailTitle');
  const body = (t('variables.contactEmailBody') || '[pdf-link]').split('[pdf-link]').join(`${pdfUrl}`);

  return `mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
export const PrintSection = ({
  pdfUrl,
  pdfError,
  isPDFLoading = false,
  emailClickRef,
  downloadClickRef,
}:
    {
      pdfUrl?: string,
      pdfError?: unknown,
      isPDFLoading?: boolean,
      emailClickRef?: React.MutableRefObject<(() => void) | null>,
      downloadClickRef?: React.MutableRefObject<(() => void) | null>,
    }) => {
  const iframeRef = useRef<HTMLIFrameElement>(null);
  const t = useTranslateFn<TranslationKey>();
  const email = t('variables.contactEmail');
  const emailLinkRef = useRef<HTMLAnchorElement | null>(null);
  const downloadLinkRef = useRef<HTMLAnchorElement | null>(null);

  const onEmail = async () => emailLinkRef.current?.click();

  if (emailClickRef) {
    // eslint-disable-next-line no-param-reassign
    emailClickRef.current = onEmail;
  }

  const onDownload = async () => downloadLinkRef.current?.click();

  if (downloadClickRef) {
    // eslint-disable-next-line no-param-reassign
    downloadClickRef.current = onDownload;
  }

  useSetPrinterActions(onEmail, onDownload);

  const mailTo = useMemo(() => emailLink(pdfUrl!, email, t), [pdfUrl, email, t]);

  return (
    <>
      <iframe title="Test" ref={iframeRef} style={{ width: '100vw', height: '100vh', display: 'none' }} />
      <div className={styles.contact}>
        {/* eslint-disable-next-line */}
        <label>{t('texts.print.contactUs')}</label>
        {/* eslint-disable-next-line */}
        <div>{t('texts.print.agreement')}</div>
        <div className={styles.buttons}>
          {!!pdfUrl && (
            <a
              href={mailTo}
              target="_blank"
              rel="noreferrer"
              ref={emailLinkRef}
            >
              <MailIconSvg className={styles.mailIcon} />
              {' '}
              {t('texts.print.sendEmail')}
            </a>
          )}
          {!!pdfUrl && (
            <a
              href={pdfUrl}
              target="_blank"
              rel="noreferrer"
              ref={downloadLinkRef}
            >
              <PrintIconSvg className={styles.printIcon} />
              {' '}
              {t('texts.print.generateBtn')}
            </a>
          )}
        </div>
        {!!pdfError && (
          <div>
            <br />
            {t('texts.print.warning')}
          </div>
        )}
        {isPDFLoading && (
          <div>
            <br />
            {t('texts.pdf.generating')}
          </div>
        )}
      </div>
    </>
  );
};
